import { render } from "./DoubleInfo.vue?vue&type=template&id=20352ec1"
import script from "./DoubleInfo.vue?vue&type=script&lang=js"
export * from "./DoubleInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../DIARC/pixonanimation.az/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__